export const messages = {
  en: {
    updatePwd: {
      title: 'Change Password',
      oldPassword: {
        label: 'Old Password',
        placeholder: 'Please input old password'
      },
      newPassword: {
        label: 'New Password',
        placeholder: 'Please input new password'
      },
      confirmPassword: {
        label: 'Confirm Password',
        placeholder: 'Please confirm new password'
      },
      button: 'Confirm'
    }
  },
  zh: {
    updatePwd: {
      title: '修改密码',
      oldPassword: {
        label: '原始密码',
        placeholder: '必填，请输入原始密码'
      },
      newPassword: {
        label: '新密码',
        placeholder: '必填，请输入新密码'
      },
      confirmPassword: {
        label: '确认密码',
        placeholder: '必填，请输入确认密码'
      },
      button: '确认修改'
    }
  }
} 